// test1950
(1950 && 0);
